export default __webpack_public_path__ + "static/media/flogo.a4e07508.svg";